import { ChatService } from "@/services";
import { CHAT_QUERY_KEYS, CommonParams } from "@/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useGetListChatMember = (
  chatId: number,
  params?: CommonParams<{}>,
) => {
  const { data, isLoading, isPending, error, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [CHAT_QUERY_KEYS.GET_LIST_CHAT_MEMBERS, chatId, params],
      queryFn: ({ pageParam = 1 }) =>
        ChatService.getListChatMembers(chatId, { ...params, page: pageParam }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) => {
        // Logic to determine the next page parameter
        return lastPage.pagination?.hasNextPage
          ? lastPage.pagination.page + 1
          : undefined;
      },
    });

  const members = useMemo(() => {
    return data?.pages.flatMap((page) => page.data) || [];
  }, [data]);

  return {
    members,
    isLoading,
    isPending,
    error,
    hasNextPage,
    fetchNextPage,
  };
};
